export default {
    category: {
        cta: "Ver productos"
    }
}